import * as React from 'react';
import cn from 'clsx';

import { IconChevronDownSmall16 } from '@cian/ui-kit';

import * as styles from './styles.css';

import { Text } from '../../Text';
import { Collapse } from './Collapse';

import { getDefaultState, getNewState } from './utils';

export interface IContent {
  title: string;
  content: React.ReactNode;
}

export interface IAccordionProps {
  content: IContent[];
  onClick?(nextActiveIndex: number): void;
  defaultIndexVisible?: number;
}

export interface IState {
  [key: string]: boolean;
}

const PADDING_TOP = 20;
const ANIMATION_DURATION = 300;

export class Accordion extends React.Component<IAccordionProps, IState> {
  public constructor(props: IAccordionProps) {
    super(props);

    const { content, defaultIndexVisible = 0 } = props;

    this.state = {
      ...getDefaultState({ ...content }, defaultIndexVisible),
    };
  }

  public componentDidUpdate() {
    setTimeout(() => {
      const activeTitle = document.querySelector(`.${styles['active']}`) as HTMLDivElement;

      if (activeTitle) {
        const isHidden = activeTitle.getBoundingClientRect().top < 0;

        if (isHidden) {
          window.scrollTo({
            top: activeTitle.offsetTop - PADDING_TOP,
            left: 0,
            behavior: 'smooth',
          });
        }
      }
    }, ANIMATION_DURATION);
  }

  public render() {
    return (
      <div>
        {this.props.content.map((item, index) => {
          const { title, content } = item;

          return (
            <React.Fragment key={title}>
              <div className={styles['container']}>
                <div
                  className={cn(styles['title'], this.state[index] && styles['active'])}
                  onClick={() => this.handleClick(index)}
                >
                  <div>
                    <Text size="h3" bold>
                      {title}
                    </Text>
                  </div>
                  <span className={styles['chevron']}>
                    <IconChevronDownSmall16 />
                  </span>
                </div>

                <Collapse isOpen={this.state[index]}>{content}</Collapse>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    );
  }

  private handleClick = (index: number) => {
    if (this.props.onClick) {
      this.props.onClick(index);
    }

    this.setState(getNewState(this.state, index));
  };
}
